import * as React from "react";
const SvgFiRrDungeon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-dungeon_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.925 0 1 4.925 1 11v9.882c0 1.451.978 2.784 2.402 3.06A3.005 3.005 0 0 0 7 21v-9.749c0-2.814 2.174-5.169 4.846-5.249a5 5 0 0 1 3.939 1.73c.826.951 1.216 2.208 1.216 3.468v9.681c0 1.451.978 2.784 2.402 3.06a3.005 3.005 0 0 0 3.598-2.942V11C23 4.925 18.075 0 12 0M5 21a1.001 1.001 0 0 1-2 0v-1h2zm0-3H3v-2h2zm0-4H3v-2h2zm.107-4H3.093a9.6 9.6 0 0 1 .731-2.566l1.735 1.002A7.4 7.4 0 0 0 5.107 10m1.459-3.292L4.824 5.702a9.3 9.3 0 0 1 1.861-1.907L7.699 5.55a7.3 7.3 0 0 0-1.133 1.157zM11 4.074a6.7 6.7 0 0 0-1.587.445l-1.01-1.75A8.6 8.6 0 0 1 11 2.055zm3.6.422A7 7 0 0 0 13 4.07V2.053a8.9 8.9 0 0 1 2.609.695zm2.901 2.173a7.2 7.2 0 0 0-1.17-1.17l1.008-1.746a9.2 9.2 0 0 1 1.909 1.906L17.5 6.668zM18.504 8.4l1.748-1.01c.36.822.594 1.7.693 2.61h-2.016a7 7 0 0 0-.425-1.6M21 21a1.001 1.001 0 0 1-2 0v-1h2zm0-3h-2v-2h2zm0-4h-2v-2h2zm-10-4v13a1 1 0 1 1-2 0V10a1 1 0 1 1 2 0m4 0v13a1 1 0 1 1-2 0V10a1 1 0 1 1 2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-dungeon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDungeon;
